import {_} from 'lodash';
import DetailsPage from "../DetailsPage";
import {IMessage, IRouteDefinition, IRouteDefinitionParams, IRuleset} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import {ObjectTypeId} from "../../constants";
import {global} from "../../appContext";
import {nsMessages} from "./fn";
import {getRouteDefinition, getTopParent, setRouteHash} from "../../constants/RouteDefinitions";
import pubsub from "../../pubsub";
import {REQUEST_MESSAGE} from "../../constants/Language";
import getAddRecipientLabel = nsMessages.getAddRecipientLabel;
import IsType = nsMessages.TypeChecker;
import detailsHtml from './details.html?raw';

export let template: string = detailsHtml;


export class viewModel extends DetailsPage<IMessage> {

    private isType: any;
    private objectTypeId: ObjectTypeId = ObjectTypeId.User;
    private ruleset: IRuleset | undefined;
    private req_deletemessage: PromiseRequest = global.getPromiseRequest("deletemessage")
    private req_getruleset: PromiseRequest = global.getPromiseRequest('getruleset')
    private req_searchmessagelog: PromiseRequest = global.getPromiseRequest('searchmessagelog')
    private getRouteDefinition = getRouteDefinition

    constructor(params: IRouteDefinitionParams) {
        super(params);
        const topParent = getTopParent(this.__routeId);
        if (topParent) {
            pubsub.on(this, 'delete.messageflow.complete', setRouteHash.bind(this, topParent));
        }
    }

    private pv = global.permissionValidator;

    protected override request(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});

        return this.__requestRouteData!
            .request()
            .then((data: IMessage[]) => {
                const message = data[0];
                if (!message) {
                    return;
                }
                this.data(message);
                const isType = new IsType(message.messagetype);
                this.isType = isType.isType.bind(isType);
                if (message.rulesetid) {
                    return this.req_getruleset.request({id: message.rulesetid})
                }
            })
            .then((data: IRuleset[] | void) => {
                if (data) {
                    this.ruleset = data[0];
                    this.objectTypeId = data[0]?.objecttype?.id ?? ObjectTypeId.User;
                }
                this.messageData(null);
                this.isReady(true);
            })
            .catch(this.onError.bind(this));
    }

    private addRecipientLabel(): string {
        const message = this.data();
        return message ? getAddRecipientLabel(message.messagetypeid) : '';
    }

    private getLogComponentParams(): IRouteDefinitionParams {
        const customDef: IRouteDefinition | any = {
            messageflow: this.data,
        };
        const def: Partial<IRouteDefinitionParams> = {
            ...(getRouteDefinition('messageflowdetailslog') ? {__routeDef: getRouteDefinition('messageflowdetailslog')!} : {}),
            __routeId: 'messageflowdetailslog',
        };
        return _.defaultsDeep(
            customDef,
            def,
            this.__routeDefinitionParams__,
        )
    }

    override dispose() {
        super.dispose();
        this.req_deletemessage.abort();
        this.req_searchmessagelog.abort();
        this.req_getruleset.abort();
    }

}
